
<div class="maincontainer font-sans gap-8">
    <!-- Transparent overlay layer - shown only when settings popup is open -->
    <div *ngIf="showSettings" class="fixed inset-0 bg-opacity-30 z-10" (click)="closeSettings()"></div>
   
    <div class="flex flex-col md:flex-row h-screen">
        <!-- Mobile Header with Menu Toggle -->
        <div class="block md:hidden bg-white p-4 shadow-sm">
            <div class="flex items-center justify-between">
                <img alt="Atlas Track Logo" class="h-8" src="assets/newui/atlasnewlogo.png"/>
                <button class="text-gray-600" (click)="toggleMenu()">
                    <i class="fas fa-bars text-xl"></i>
                </button>
            </div>
        </div>

        <!-- Sidebar - Hidden on mobile by default, shown when toggled -->
        <div class="w-full md:w-80 bg-white p-4   sidebar-menu" [ngClass]="{'hidden': !menuOpen, 'block': menuOpen, 'md:block': true}">
            <div class="flex items-center justify-center h-12 md:h-16 mb-6">
                <img alt="Atlas Track Logo" class="max-w-full h-auto" src="assets/newui/atlasnewlogo.png" width="180"/>
            </div>
            <div class="mt-4 md:mt-10">
                <a class="flex items-center py-2 px-4 md:px-8 hover:bg-purple-50 hover:rounded-lg text-gray-900 hover:text-purple-700 cursor-pointer" (click)="onHomeClick()">
                    <i class="fas fa-th-large mr-3"></i>
                    <span>Home</span>
                </a>
                
                <!-- Reports Dropdown Menu -->
                <div class="relative">
                    <!-- Reports Menu Header -->
                    <a class="flex items-center py-2 px-4 md:px-8 text-gray-600 mt-3 hover:bg-purple-50 hover:rounded-lg hover:text-purple-700 cursor-pointer" (click)="toggleReportsDropdown()">
                        <i class="fas fa-file-alt mr-3"></i>
                        <span>Download Reports</span>
                        <i class="fas fa-caret-down ml-auto" [ngClass]="{'transform rotate-180': reportsDropdownOpen}"></i>
                    </a>
                    
                    <!-- Dropdown Items -->
                    <div class="pl-8 md:pl-12 overflow-hidden transition-all duration-300" [ngClass]="{'max-h-0': !reportsDropdownOpen, 'max-h-48': reportsDropdownOpen}">
                        <a class="flex  items-center py-3 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onBILOGReport()">
                            <i class="fas fa-file-alt mr-3"></i>
                            <span>Biological Indicator Report</span>
                        </a>
                        <a class="flex items-center py-2 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onUltrasonicReport()">
                            <i class="fas fa-file-alt mr-3"></i>
                            <span>Ultrasonic/Washer Report</span>
                        </a>
                        <a class="flex items-center py-2 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onWaterTestReport()">
                            <i class="fas fa-file-alt mr-3"></i>
                            <span>Waterline Test Report</span>
                        </a>
                    </div>
                </div>
                
                <a class="flex  items-center py-2 mt-3 px-4 md:px-8 text-gray-600 hover:bg-purple-50 hover:text-purple-700 hover:rounded-lg" (click)="onDeviceDetailClick()">
                    <i class="fas fa-database mr-3"></i>
                    <span>Biological Indicator Device</span>
                </a>
            </div>
        </div>
        
        
        <!-- Main Content -->
        <div class="flex-1 flex flex-col">
            <!-- Header -->
            <header class="flex items-center justify-between h-16 md:h-24 px-4 md:px-6 bg-white shadow-sm md:shadow-none">
                <div class="flex items-center">
                    <h1 class="text-gray-600 text-sm font-medium">
                        Dashboard / Ultrasonic-Washer Report
                    </h1>
                </div>
                <div class="flex items-center">
                    <div class="relative">
                    </div>
                    <div class="flex items-center gap-2 md:gap-4">
                        <i class="fas fa-bell text-gray-400 mr-2 md:mr-4"></i>
                    
                        <div class="relative">
                            <div class="flex items-center gap-2 cursor-pointer z-20" (click)="toggleSettings($event)">
                                <img alt="User Avatar" class="rounded-full w-8 h-8 md:w-10 md:h-10" src="assets/newui/demoprofile.png" />
                                <span class="text-gray-600 hidden sm:inline">{{username}}</span>
                                <i class="fas fa-caret-down ml-auto"></i>
                            </div>
                            
                            <!-- Setting popup with relative positioning and higher z-index -->
                            <div *ngIf="showSettings" class="bg-white shadow-xl rounded-lg p-3 absolute right-0 top-full mt-2 z-20 w-48 md:w-64">
                                <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onManageAccount()">
                                    <img src="assets/newui/icons/manageAccountIcon.png" class="w-4 h-4" alt="">
                                    <p class="text-sm"> Manage Account </p>
                                </div>
                                <hr class="mt-2">
                                <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onForgetPassword()">
                                    <img src="assets/newui/icons/changePasswordIcon.png" class="w-4 h-4 mt-1" alt="">
                                    <p class="text-sm"> Change Password </p>
                                </div>
                                <!-- <hr class="mt-2">
                                <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer">
                                    <img src="assets/newui/icons/activityLogIcon.png" class="w-4 h-4 mt-1" alt="">
                                    <p class="text-sm"> Activity Log </p>
                                </div> -->
                                <hr class="mt-2">
                                <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onLogoutClick()">
                                    <img src="assets/newui/icons/logoutIcon.png" class="w-5 h-4 mt-1" alt="">
                                    <p class="text-sm"> Logout </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            
           
           <!-- Main Section -->
           <main class="flex-1 p-3 md:p-6 overflow-auto">
               <div class="bg-gradient-to-l from-[rgba(173,0,255,0.75)] to-[rgba(173,0,255,1)] h-36 md:h-48 rounded-lg mb-4 md:mb-6">
                <p class="font-semibold lg:text-3xl text-2xl text-white  p-10">Hello Team {{username}},</p>  
            </div>
               
               <div class="bg-white p-3 md:p-6 rounded-lg shadow-xl">
                   <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 space-y-3 md:space-y-0">
                       <div class="flex flex-col sm:flex-row lg:mt-2 items-start sm:items-center space-y-2 sm:space-y-0 sm:space-x-4">
                        <p>Start Date</p>
                           <input class="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-lg  sm:mb-0" type="date" [(ngModel)]="startTime" (change)="onDateChange()"/>
                           <p>End Date</p>
                           <input class="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-lg" type="date" [(ngModel)]="endTime" (change)="onDateChange()"/>
                           <div class="flex flex-col sm:flex-row lg:mt-2 items-start sm:items-center space-y-2 sm:space-y-0 sm:space-x-4">
                            <p>
                             Test Type
                            </p>
                            <select class="w-full sm:w-auto px-1 py-2 border border-gray-300 rounded-lg  sm:mb-0"
                            [(ngModel)]="selectedTestType" (change)="onTestTypeChange()">
                             <option value="Ultrasonic Log">Ultrasonic Log</option>
                             <option value="Washer Log">Washer Log</option>
                            </select>
                            </div>
                      
                        </div>
                      
                       <div>
                  
                       <div class="flex space-x-2 md:space-x-4">
                           <button class="flex-1 md:flex-none px-3 md:px-4 py-2  bg-red-100 text-red-600 rounded-lg text-sm md:text-base hover:shadow-md" (click)="exportPDF()">
                               PDF
                               <i class="fas fa-download text-red-500 ml-2"></i>
                           </button>
                           <button class="flex-1 md:flex-none px-3 md:px-4 py-2 bg-green-100 text-green-600 rounded-lg text-sm md:text-base" (click)="exportExcel()">
                               Excel
                               <i class="fas fa-download text-green-500 ml-2"></i>
                           </button>
                       </div>
                       </div>
                   </div>
                   
                   <!-- Responsive Table - Scrollable horizontally on small screens -->
                   <div class="overflow-x-auto -mx-3 md:mx-0">
                       <table class="min-w-full text-sm text-center">
                         <!-- In the table header, add *ngIf condition -->
<thead class="columnheading rounded-lg">
    <tr>
        <th class="py-1 px-1 border-b border-gray-200">Record</th>
        <th class="py-1 px-4 border-b border-gray-200">Date</th>
        <th class="py-1 px-4 border-b border-gray-200">Test Type</th>
        <!-- Add *ngIf to conditionally render the Solutions Changed column -->
        <th *ngIf="selectedTestType === 'Ultrasonic Log'" class="py-1 px-4 border-b border-gray-200">Solutions Changed & Degassed</th> 
        <th class="py-2 px-4 border-b border-gray-200">Test Result</th>
        <th class="py-2 px-4 border-b border-gray-200">Team Members</th>
        <th class="py-1 px-3 border-b border-gray-200">Efficacy Test Type</th>
    </tr>
</thead>
<tbody class="bg-white">
    <tr *ngFor="let record of filteredRecords.length > 0 ? filteredRecords : records; let i = index" class="text-center">
        <td class="py-2 text-sm px-1 border-b border-gray-200">{{ i+1 }}</td>
        <td class="py-2 px-4 border-b border-gray-200">{{ record.date| date:'dd-MM-yy HH:mm' }}</td>
        <td class="py-2 px-4 border-b border-gray-200">{{ record.testType }}</td> 
        <!-- Add *ngIf to conditionally render the Solutions Changed column -->
        <td *ngIf="selectedTestType === 'Ultrasonic Log'" class="py-2 px-1 border-b border-gray-200" 
            [ngClass]="{
                'text-green-500': record.solutionChanged, 
                'text-red-500': !record.solutionChanged
            }">
            {{ record.solutionChanged ? 'Yes' : 'No' }}
        </td>
        
        <td class="py-2 px-1 border-b border-gray-200 text-red-500" 
            [ngClass]="{
                'text-green-500': record.result === 'Pass', 
                'text-red-500': record.result === 'Fail', 
                'text-gray-500': record.result !== 'Pass' && record.result !== 'Fail'
            }">
            {{ record.result }}
        </td>
        <td class="py-2 px-1 border-b border-gray-200">{{ record.technicianName }}</td>
        <td class="py-2 px-1 border-b border-gray-200">{{ record.efficacyTestName }}</td>
    </tr>
</tbody>
                       </table>
                   </div>
                   
                   <!-- Pagination -->
                   <div class="mt-4 flex flex-col sm:flex-row items-center justify-between">
                       <span class="mb-2 sm:mb-0 text-sm md:text-base">Page {{ currentPage + 1 }} of {{ totalPages }}</span>
                       <div class="flex items-center">
                           <button class="px-3 md:px-4 py-1 md:py-2 rounded-lg mr-2 disabled:opacity-50"
                           (click)="changePage(currentPage - 1)" 
                           [disabled]="currentPage === 0">
                               &lt;
                           </button>
                           <button class="px-3 md:px-4 py-1 md:py-2 bg-gray-100 text-gray-600 rounded-lg disabled:opacity-50" 
                           (click)="changePage(currentPage + 1)" 
                           [disabled]="currentPage === totalPages || totalPages == currentPage + 1">
                               &gt;
                           </button>
                       </div>
                   </div>
               </div>
           </main>
       </div>
   </div>
   
   <app-notification-popup
       [isOpen]="showPopup"
       [message]="popupMessage"
       [type]="popupType"
       (onClose)="closePopup()">
   </app-notification-popup>
</div>